/**
 * 跳转到医生工作台
 */
import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Dispatch, RootState } from '@/store';
import { TYPE_SWITCH } from '@/schemas/common';
import { sendClick } from '@/utils/helpers';
import IconRecord from '@assets/home/nav-icon-switch.png';
import { getTargetUrl } from '@/utils/url';

import styles from './index.module.scss';

const mapState = (state: RootState) => ({
  isDoctor: state.user.doctor,
  openServiceStatus: state.user.openServiceStatus // 是否开通了咨询服务
});

const mapDispatch = (dispatch: Dispatch) => ({});

type IProps = ReturnType<typeof mapDispatch> &
  ReturnType<typeof mapState> & { isScroll; type };

const Com = (props: IProps) => {
  const { isScroll, isDoctor, type } = props;
  const history = useHistory();

  const handleClick = () => {
    sendClick('SWITCH_BUTTON');
    if (type === TYPE_SWITCH.WORKSTATION) {
      // 判断跳转工作台还是服务介绍页
      history.replace(getTargetUrl('/doctor-workstation'));
    } else if (type === TYPE_SWITCH.CHANNEL) {
      history.replace('/?from=workstation');
    }
  };

  return (
    <>
      {isDoctor && (
        <div
          role="presentation"
          className={`${styles['nav-workstation']} ${
            isScroll ? styles['scroll'] : ''
          }`}
          onClick={handleClick}
        >
          <i
            style={{
              backgroundImage: `url(${IconRecord})`
            }}
          />
          <p>{type === TYPE_SWITCH.WORKSTATION ? '医生端' : '健康频道'}</p>
        </div>
      )}
    </>
  );
};

export default connect(mapState, mapDispatch)(Com);
